/*eslint-disable */
import {
  mapGetters,
} from 'vuex';
import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';
var $ = window.jQuery = jQuery = require('jquery');
import toast from '../../services/toast';
export default {
  name: 'userImage',
  components: {
    VueCropper
  },
  props: [],
  data() {
    return {
      avatar: '',
      overlay: false,
      showModal: false,
      cropImg: '',
      imgSrc: '',
      data: null,
      userDetails:'',
      department:'',
      area_of_work:'',
      area_of_interest:'',
      filename:'',
      userImgLoading:false,
      thumbnail:''
    }
  },
  computed: {
    ...mapGetters([
      'acUserDetailsStateGetters'
    ]),
    getUserDetailsAgainFun(){
    this.userDetails = this.$store.getters.acUserDetailsStateGetters.data
    return
    },
    setInitialState(){
      if(this.userDetails != undefined){
        this.avatar = this.userDetails.profile.avatar
        this.thumbnail = this.userDetails.profile.thumbnail
      }
    }
  },
  mounted() {
    this.getUserDetailsAgainFun;
    this.setInitialState
  },
  methods: {
    cancelCrop() {
      this.$refs.cropper.reset();
      this.imgSrc = '';
      this.filename = '';
    },
    setImage(e) {
      const file = e.target.files[0];
      this.filename = file.name;
      console.log(file, "slect file")
      if (file.type.indexOf('image/') === -1) {
        alert('Please select an image file');
        return;
      }
      if (typeof FileReader === 'function') {
        const reader = new FileReader();
        reader.onload = (event) => {
          this.imgSrc = event.target.result;
        };
        reader.readAsDataURL(file);
      } else {
        alert('Sorry, FileReader API not supported');
      }
    },
    cropImage() {
      this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
      let cropperImg = this.cropImg;
      cropperImg = cropperImg.replace(/^data:image\/(png|jpg);base64,/, "")
      let data = {
        "avatar": cropperImg,
        "filename":this.filename
      }
      this.userImgLoading = true
      this.$store.dispatch('updateProfileAvatarFun', data).then((res) => {
        this.imgSrc = '';
        toast.success(res.data.msg);
        this.$store.dispatch('getAcUserDetailsFun').then((res) => {
        this.thumbnail = res.data.data.profile.thumbnail
        this.avatar = res.data.data.profile.avatar;
        })
        this.userImgLoading = false
      }).catch((err)=>{
        toast.error('Media not supported');
        this.userImgLoading = false
      })
    },
    getImgUrl(pic) {
      if (pic == '' || !pic || pic == 'undefined') {
        return require('./../../assets/images/user_default.png')
      } else {
        return pic
      }
    },
    removeImage() {
      this.$store.dispatch('removeProfileAvatarFun').then((res) => {
        if (res.status == '200') {
          this.$store.dispatch('getAcUserDetailsFun').then((res) => {
            this.thumbnail = res.data.data.profile.thumbnail
            this.avatar = res.data.data.profile.avatar;
          })
          return
        }
      }).catch((err) => {
      })
    },
    showOverlay() {
      this.showModal = true;
      $('body').addClass('showoverlay');
    },
    hideOverlay() {
      this.showModal = false;
      this.imgSrc = '';
      $('body').removeClass('showoverlay');
    }
  },
  watch: {
  getUserDetailsAgainFun(){
    return this.$store.getters.acUserDetailsStateGetters.data
  },
  setInitialState(){
    if(this.userDetails != undefined){
      this.avatar = this.userDetails.profile.avatar
      this.thumbnail = this.userDetails.profile.thumbnail
    }
  }
  }
}